import type { PackingListRow } from "@RequestFormV2/sections/PackingList/types";
import { projectCommodityRows } from "@RequestFormV2/sections/PackingList/utils/commodityProjection";
import { isContainerRow } from "@RequestFormV2/sections/PackingList/utils/packingListSplit";

export function clonePackingListRow(row: PackingListRow): PackingListRow {
  if (!isContainerRow(row)) {
    // Handling-unit commodities are managed in CommoditiesSection, not on the row itself.
    const { good_customs_information: _commodities, ...handlingUnitFields } = row;
    return handlingUnitFields;
  }

  return {
    ...row,
    good_customs_information: row.good_customs_information
      ? row.good_customs_information.map((entry) => ({ ...entry }))
      : row.good_customs_information,
  };
}

export function countSameKindRows(rows: PackingListRow[], row: PackingListRow | undefined) {
  if (!row) return 0;
  const isContainer = isContainerRow(row);
  return rows.filter((item) => isContainerRow(item) === isContainer).length;
}

export function canDeletePackingListRow(rows: PackingListRow[], index: number) {
  const row = rows[index];
  if (!row) return false;
  // Handling units (including the last one) can always be removed so packing can be container-only.
  if (!isContainerRow(row)) return true;
  return countSameKindRows(rows, row) > 1;
}

export function canDeleteCommodity(rows: PackingListRow[]) {
  return projectCommodityRows(rows).length > 1;
}

export function findPackingListIndexByFieldId(fields: { id: string }[], fieldId: string) {
  return fields.findIndex((field) => field.id === fieldId);
}
